import trackEvent, { ANALYTICS_EVENTS } from './analytics';
import { CollectError, ErrorTracking } from '../config';

function getMessageOrigin(event) {
  return event.origin || event.originalEvent.origin;
}

function onWindowMessage(message, callback) {
  window.addEventListener('message', (event) => {
    const { data } = event;
    const origin = getMessageOrigin(event);
    const { messageName, payload } = data;
    const allowedDomain =
      window.getAllowedDomains().length === 0 ? true : window.getAllowedDomains().indexOf(origin) !== -1;
    if (!allowedDomain) {
      throw new CollectError(`${origin} is not whitelisted. Please contact VGS support.`);
    } else if (messageName === message && allowedDomain) {
      callback(payload);
    }
  });
}

const isSubmitCallback = (messageName) => typeof messageName === 'string' && messageName.startsWith('submitCallback');

function sendMessage(domain, w, messageName, payload, callback) {
  try {
    w.postMessage({ messageName, payload }, domain);
    if (isSubmitCallback(messageName)) {
      trackEvent({
        type: ANALYTICS_EVENTS.POST_MESSAGE,
        status: 'Ok',
        messageName,
        domain,
      });
    }
  } catch (e) {
    const info = {
      domain,
      messageName,
      name: e && e.name,
      message: e && e.message,
    };
    ErrorTracking.error('postMessage crashed in iframe', e, info);
    trackEvent({
      type: ANALYTICS_EVENTS.POST_MESSAGE,
      status: 'Failed',
      ...info,
    });
  }
}

export function unsafeListen(messageName, callback) {
  return onWindowMessage(messageName, callback);
}

export function unsafeSend(...args) {
  return sendMessage('*', ...args);
}
